
<section class="breadcrumb-banner">
	<div class="container">
		<div class="row">
			<div class="col-md-12 col-lg-12">
				<div class="breadcrumb-text">
					<h1>Musical Tribute </h1>
				</div>
			</div>
		</div>
	</div>
    <div class="breadcrumb-bottom-img">
        <img
            src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.png"  alt="GHRSCF"/>
    </div>
</section>
<section class="section section-sm raagas-urvashi section-banner-bg-1">
    <div class="container">
        <div class="row justify-content-center align-items-center">

            <div class="sec-title text-center">
                <h2>Forever Lata : <span > -
                    A Musical Tribute to Bharat Ratna Lata Mangeshkar Chandrapur</span></h2>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <p class="text-justify">G. H Raisoni Sports and Cultural Foundation organizes ‘Forever Lata’ - A
                        Musical Tribute to Lata Mangeshkar ji. The event is powered by the Raisoni Group of Institutions
                        and supported by G H Raisoni University, and SGR Knowledge Foundation. ‘Forever Lata’ is a
                        heartfelt tribute that aims to celebrate the exceptional music of the legendary singer Lata
                        Mangeshkar. The grand event features a group of highly talented and well-known artists from
                        Nagpur’s musical group ‘Sur Sangam’, who performs Lata Mangeshkar's timeless songs, recalling
                        her immense contribution to Indian cinema. </p>
                    <p class="text-justify">Earlier GHRSCF had organized the event in Nagpur, Chandrapur, Wardha and
                        extended to other different cities across Maharashtra. The event’s success usually depends on
                        the testament to the passion and commitment of the organizer G H Raisoni Sports and Cultural
                        Foundation fits in and celebrates India’s rich cultural heritage by organizing such events for
                        the general public, free of charge. The Initiative is supported and encouraged by Shri Sunil
                        Raisoni, Chairman, Raisoni Group of Institutions, He has been a driving force behind the event,
                        and has made this initiative possible.</p>
                    <p class="text-justify">All the music enthusiasts, cinephiles, and the general public are invited to
                        join the upcoming event. For more details and registration visit the following link <a
                            href="https://www.ghrscf.com/cultural-events">Link:-https://www.ghrscf.com/cultural-events</a>
                    </p>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-8">

                    <p><strong>Let’s meet you then.</strong></p>

                    <p><b>Topic: A Musical Tribute to Bharat Ratna - Lata Mangeshka </b></p>
                    <p><b>Date – Saturday, 29<sup>th</sup> April 2023 </b></p>
                    <p><b>Time – 06:30 pm - Sharp (Grab your seats before time)</b></p>
                    <p><b>Venue: Priyadarshini Hall, Chandrapur </b></p>
                </div>
                <div class="col-md-4">
                    <div class="image-effect-2">
                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/lata-mangeshkar.png"
                            alt="GHRSCF" style="width: 100%;">
                    </div>
                </div>
            </div>
        </div>

        <div class="border-line-sm"></div>
        <div class="row">
            <!-- <div class="col-lg-6">
                <div class="gall-ery">
                    <div class="row">
                        <div class="col-md-8">
                            <div class="widget_title inner-title gall-sys shadow-text-sm">
                                <h4 class="fw-bold">Media Coverage</h4>
                            </div>
                        </div>
                        <div class="col-md-4 text-end">
                            <a href="https://drive.google.com/file/d/1nTCH5jrvPhQn7-6fDqzppyAZBTPPEaEa/view?usp=sharing"   class="btn button--effect-1"><span>
                                View More</span> <i class="fa fa-caret-square-o-right" aria-hidden="true"></i>
                            </a>
                        </div>
                    </div>
                    <iframe width="100%" height="230" src="https://drive.google.com/file/d/1nTCH5jrvPhQn7-6fDqzppyAZBTPPEaEa/preview" allowfullscreen></iframe>

                </div>
            </div> -->
            <div class="col-lg-6">
                <div class="gall-ery">
                    <div class="row">
                        <div class="col-md-8">
                            <div class="widget_title inner-title gall-sys shadow-text-sm">
                                <h4 class="fw-bold">Photos</h4>
                            </div>
                        </div>
                        <div class="col-md-4 text-end">
                            <a href="photogallery#lata-mageshkar-chandrapur-event" class="cmn-button"><span>
                                    View More</span>
                            </a>
                        </div>
                    </div>
                    <div class="lightBox--gallery">
                        <ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-3">
                            <li class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/lata-5.webp"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/lata-5.webp">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/lata-5.webp"
                                        alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img
                                            src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                    </div>
                                </a>
                            </li>
                            <li class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/lata-1.webp"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/lata-1.webp">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/lata-1.webp"
                                        alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img
                                            src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                    </div>
                                </a>
                            </li>
                            <li class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/lata-2.webp"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/lata-2.webp">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/lata-2.webp"
                                        alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img
                                            src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                    </div>
                                </a>
                            </li>
                            <li class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/lata-3.webp"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/lata-3.webp">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/lata-3.webp"
                                        alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img
                                            src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                    </div>
                                </a>
                            </li>
                            <li class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/lata-4.webp"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/lata-4.webp">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/lata-4.webp"
                                        alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img
                                            src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                    </div>
                                </a>
                            </li>
                            <li class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/lata-6.webp"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/lata-6.webp">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/lata-6.webp"
                                        alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img
                                            src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                    </div>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>

        </div>
    </div>
</section>
